import {useConfig} from '@lore/config';
import getEventShareUrl from '@/features/share-event/utils/getEventShareUrl';

export default function useEventShareActions(event) {
  const config = useConfig();
  const shareUrl = getEventShareUrl(config, event);

  return {
    onEmail: () => {
      window.location.href = `mailto:?subject=${encodeURIComponent(event.data.title)}&body=${encodeURIComponent(shareUrl)}`;
    },
    onLinkedIn: () => {
      window.open(`https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(shareUrl)}`, '_blank');
    },
    onFacebook: () => {
      window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}`, '_blank');
    },
    onCopyLink: () => {
      navigator.clipboard.writeText(shareUrl);
    }
  };
}
